module.exports = __webpack_public_path__ + "img/icon-volume-on.19be08b2.svg";